import { Component, Input } from '@angular/core';
import { ModalController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Globals } from '../../../../globals';
import { OrdersCoServices } from '../../../orders/services';
import { TPVServices } from '../../../tpv/services';
import { VariationsProductSelectorPage } from '../../../variations/variations-product-selector/variations-product-selector';
import { VariationsDishSelectorPage } from '../../../variations/variations-dish-selector/variations-dish-selector';
import { TranslateService } from '@ngx-translate/core';
import { TakeawayServices } from '../../../takeaway/services';
import { PosComboPage } from '../pos-combo/pos-combo';

/**
 * Generated class for the  page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-pos-favourite',
  templateUrl: 'pos-favourite.html',
})
export class PosFavouritePage {

  @Input() element_type: string;
  @Input() platform: string;
  @Input() element: any;
  @Input() origin: string;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public globals: Globals,
    private tpvServices: TPVServices,
    public ordersCoServices: OrdersCoServices,
    public translate: TranslateService,
    public toastCtrl: ToastController,
    public takeawayServices: TakeawayServices,
    public modalCtrl: ModalController) {
  }


  insertToTicket(element, _name, _price, _delete, _count, _type, _uid, _section) {
    if (this.origin === 'comandero') {
      this.ordersCoServices.insertTable(_name, _price, _delete, _count, _type, _uid, _section, element);

      let toast = this.toastCtrl.create({
        message: _name + " " + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'top'
      });
      this.ordersCoServices.count_elements++;//insert ++
      toast.present();
    } else {
      this.takeawayServices.insertTable(_name, _price, _delete, _count, _type, _uid, _section, element);

      let toast = this.toastCtrl.create({
        message: _name + " " + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

  insertToTicketProduct(product, _price, _delete, _count, _type, _uid, _section) {
    if (this.origin === 'comandero') {
      let _name = '';

      //Comprovamos que el producto tenga el idioma seleccionado
      if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
        this.ordersCoServices.insertTable(this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product), _price, _delete, _count, _type, _uid, _section, product);
        _name = this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product);
      } else {
        this.ordersCoServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, _section, product);
        _name = 'no name - ' + _price;
      }

      let toast = this.toastCtrl.create({
        message: _name + ' ' + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'top'
      });
      this.ordersCoServices.count_elements++;//insert ++
      toast.present();
    } else {
      let _name = '';
      //Comprovamos que el producto tenga el idioma seleccionado
      if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
        this.takeawayServices.insertTable(this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product), _price, _delete, _count, _type, _uid, _section, product);
        _name = this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product);
      } else {
        this.takeawayServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, _section, product);
        _name = 'no name - ' + _price;
      }
      let toast = this.toastCtrl.create({
        message: _name + ' añadido correctemente',
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

  insertToTicketDish(dish, _price, _delete, _count, _type, _uid, _section) {
    if (this.origin === 'comandero') {
      //Comprovamos que el plato tenga el idioma seleccionado
      if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
        this.ordersCoServices.insertTable(this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish), _price, _delete, _count, _type, _uid, _section, dish);
      } else {
        this.ordersCoServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, _section, dish);
      }


      let toast = this.toastCtrl.create({
        message: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish) + " " + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'top'
      });
      this.ordersCoServices.count_elements++;//insert ++
      toast.present();
    } else {
      //Comprovamos que el plato tenga el idioma seleccionado
      if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
        this.takeawayServices.insertTable(this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish), _price, _delete, _count, _type, _uid, _section, dish);
      } else {
        this.takeawayServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, _section, dish);
      }


      let toast = this.toastCtrl.create({
        message: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish) + " " + this.translate.instant('instant-anadido-correctemente'),
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
  }

  lpDish(dish, _price, _priceHalf, _priceTapa, _type, _uid, section) {
    if (this.origin === 'comandero') {
      //Comprovamos que el plato tenga el idioma seleccionado
      if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish),
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'comandero',
          tags: dish.tags,
        });
      } else {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: 'no name - ' + _price,
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'comandero',
          tags: dish.tags,
        });
      }
    } else {
      //Comprovamos que el plato tenga el idioma seleccionado
      if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish),
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'takeaway',
          tags: dish.tags,
        });
      } else {
        this.navCtrl.push(VariationsDishSelectorPage, {
          name: 'no name - ' + _price,
          price: _price,
          price12: _priceHalf,
          priceTapa: _priceTapa,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'takeaway',
          tags: dish.tags,
        });
      }
    }

  }

  variationProduct(product, pvp, pvp2, pvp3, _type, _uid, section) {
    if (this.origin === 'comandero') {
      if (!pvp2) {
        pvp2 = 0;
      }
      if (!pvp3) {
        pvp3 = 0;
      }
      //Comprovamos que el producto tenga el idioma seleccionado
      if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
        this.navCtrl.push(VariationsProductSelectorPage, {
          name: this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product),
          pvp: pvp,
          pvp2: pvp2,
          pvp3: pvp3,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'comandero',
          tags: product.tags,
        });
      } else {
        this.navCtrl.push(VariationsProductSelectorPage, {
          name: 'no name - ' + pvp,
          pvp: pvp,
          pvp2: pvp2,
          pvp3: pvp3,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'comandero',
          tags: product.tags,
        });
      }
    } else {
      if (!pvp2) {
        pvp2 = 0;
      }
      if (!pvp3) {
        pvp3 = 0;
      }
      //Comprovamos que el producto tenga el idioma seleccionado
      if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
        this.navCtrl.push(VariationsProductSelectorPage, {
          name: this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product),
          pvp: pvp,
          pvp2: pvp2,
          pvp3: pvp3,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'takeaway',
          tags: product.tags,
        });
      } else {
        this.navCtrl.push(VariationsProductSelectorPage, {
          name: 'no name - ' + pvp,
          pvp: pvp,
          pvp2: pvp2,
          pvp3: pvp3,
          type: _type,
          uid: _uid,
          section: section,
          sender: 'takeaway',
          tags: product.tags,
        });
      }
    }
  }

  changeSelectMenuSelected(menu) {
    if (this.origin === 'comandero') {
      this.ordersCoServices.section_menu_order = menu.sections[0].name;

      this.ordersCoServices.menu_select = menu.UID;
    } else {
      this.takeawayServices.section_menu_order = menu.sections[0].name;

      this.takeawayServices.menu_select = menu.UID;
    }
  }

  //TPV
  lpDishTPV(dish, _price, _priceHalf, _priceTapa, _type, _uid) {

    //Comprovamos que el plato tenga el idioma seleccionado
    if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
      this.navCtrl.push(VariationsDishSelectorPage, {
        name: this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish),
        price: _price,
        price12: _priceHalf,
        priceTapa: _priceTapa,
        type: _type,
        uid: _uid,
        sender: 'tpv',
        tags: dish.tags,
      });
    } else {
      this.navCtrl.push(VariationsDishSelectorPage, {
        name: 'no name - ' + _price,
        price: _price,
        price12: _priceHalf,
        priceTapa: _priceTapa,
        type: _type,
        uid: _uid,
        sender: 'tpv',
        tags: dish.tags,
      });
    }
    this.tpvServices.autoScrollEnterElements();
  }


  insertToTicketDishTPV(dish, _price, _delete, _count, _type, _uid) {

    this.tpvServices.deleteKeyboard();
    //Comprovamos que el plato tenga el idioma seleccionado
    if (this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish)) {
      this.tpvServices.insertTable(this.tpvServices.nameLangSelect(this.globals.restaurant.lang, dish), _price, _delete, _count, _type, _uid, dish);
    } else {//Si el plato no tiene nombre en el idioma seleccionado, pasamos un string
      this.tpvServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, dish);
    }

    if (this.globals.tour != '') {
      this.globals.tour_step_user = 5;
    }
    this.tpvServices.autoScrollEnterElements();
  }

  variationProductTPV(product, pvp, pvp2, pvp3, _type, _uid) {
    if (!pvp2) {
      pvp2 = 0;
    }
    if (!pvp3) {
      pvp3 = 0;
    }

    //Comprovamos que el producto tenga el idioma seleccionado
    if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
      this.navCtrl.push(VariationsProductSelectorPage, {
        name: this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product),
        pvp: pvp,
        pvp2: pvp2,
        pvp3: pvp3,
        type: _type,
        uid: _uid,
        sender: 'tpv',
        tags: product.tags,
      });
    } else {
      this.navCtrl.push(VariationsProductSelectorPage, {
        name: 'no name - ' + pvp,
        pvp: pvp,
        pvp2: pvp2,
        pvp3: pvp3,
        type: _type,
        uid: _uid,
        sender: 'tpv',
        tags: product.tags,
      });
    }
    this.tpvServices.autoScrollEnterElements();
  }

  insertToTicketProductTPV(product, _price, _delete, _count, _type, _uid) {
    //Comprovamos que el producto tenga el idioma seleccionado
    if (this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product)) {
      this.tpvServices.insertTable(this.tpvServices.nameProductLangSelect(this.globals.restaurant.lang, product), _price, _delete, _count, _type, _uid, product);
    } else {//Si el producto no tiene nombre en el idioma seleccionado, pasamos un string
      this.tpvServices.insertTable('no name - ' + _price, _price, _delete, _count, _type, _uid, product);
    }

    this.tpvServices.change_units = true;

    this.tpvServices.autoScrollEnterElements();
  }

  /*insertToTicketMenuTPV(element,_name, _price, _delete, _count, _type, _uid) {

    this.tpvServices.insertTable(_name, _price, _delete, _count, _type, _uid, element.tags);

    this.tpvServices.autoScrollEnterElements();
  }*/


  insertToTicketMenuTPV(element, _name, _price, _delete, _count, _type, _uid) {
    this.tpvServices.deleteKeyboard();
    if (element.style == 'combo') {
      let profileModal = this.modalCtrl.create(PosComboPage,
        {
          combo: this.element,
          origin: 'tpv'
        });
      profileModal.onDidDismiss(data => { });
      profileModal.present();
    } else {
      this.tpvServices.insertTable(_name, _price, _delete, _count, _type, _uid, {});

      this.tpvServices.autoScrollEnterElements();
    }


  }







}


// WEBPACK FOOTER //
// ./src/pages/components/pos/pos-favourite/pos-favourite.ts